import { render, staticRenderFns } from "./BezorglijstTable.vue?vue&type=template&id=4d6aedca&scoped=true&"
import script from "./BezorglijstTable.vue?vue&type=script&lang=js&"
export * from "./BezorglijstTable.vue?vue&type=script&lang=js&"
import style0 from "./BezorglijstTable.vue?vue&type=style&index=0&id=4d6aedca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6aedca",
  null
  
)

export default component.exports